import { shallowRef } from 'vue'
export function useTopErrors() {
  const topErrors = shallowRef([])
  const updateErrors = (errors) => {
    topErrors.value = errors ?? []
  }

  const topSuccess = shallowRef([])
  const updateSuccess = (success) => {
    topSuccess.value = success ?? []
  }

  return {
    topErrors,
    updateErrors,
    topSuccess,
    updateSuccess,
  }
}
